import {ErrorDtoFactory, ConversionDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as FlyerConversionSettingAction} from "../actions/flyerConversionSettingsActions";

import {ActionType} from "../actionTypes";
import axios from "axios";
import envManager from "../../com/envManager/EnvManager";

export const getConversionUrlSettings = (flyerId?: number) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerConversionSettingAction>) => {
        dispatch({
            type: ActionType.GET_CONVERSION_URL_START
        })
        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            const url = flyerId ? `${envManager.flyerEditorServerAddress}/api/Flyers/GetFlyerConversionSettings/${userDto.userId}/${flyerId}` : `${envManager.flyerEditorServerAddress}/api/Account/GetConversionSettings/${userDto.userId}`;
            let result = await axios.get(url, config);
            let data = result.data.data;

            dispatch({
                type: ActionType.GET_CONVERSION_URL_SUCCESS,
                payload: data
            })

            dispatch({
                type: ActionType.GET_CONVERSION_URL_COMPLETED
            })
        }
        catch(err){
            dispatch({
                type: ActionType.GET_CONVERSION_URL_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

export const saveConversionUrlSettings = (dataForRequest: ConversionDto, settingForAccount: boolean, flyerId?: number) => {
    let userDtoStr = localStorage.getItem('userDto');
    let userDto: UserDto = JSON.parse(userDtoStr!);

    return async (dispatch: Dispatch<FlyerConversionSettingAction>) => {
        dispatch({
            type: ActionType.POST_CONVERSION_URL_START
        })
        try
        {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            const url = flyerId && !settingForAccount ? `${envManager.flyerEditorServerAddress}/api/Flyers/SetFlyerConversionSettings/${userDto.userId}/${flyerId}`: `${envManager.flyerEditorServerAddress}/api/Account/SetConversionSettings`
            let result = await axios.post(url, dataForRequest, config);
            dispatch({
                type: ActionType.POST_CONVERSION_URL_SUCCESS,
                payload: dataForRequest
            })

            dispatch({
                type: ActionType.POST_CONVERSION_URL_COMPLETED
            })
        }
        catch(err){
            dispatch({
                type: ActionType.POST_CONVERSION_URL_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }
}

